import React from "react";
import InlineStat from "./component/InlineStat";

import tree from "../../assets/image/tree.svg";
import car from "../../assets/image/car.svg";
import petrolpump from "../../assets/image/petrolpump.svg";
import location from "../../assets/image/location.svg";
import location_light from "../../assets/image/location_light.svg";
import powerlogo from "../../assets/image/powerlogo.svg";
import bmsLogo from "../../assets/image/bmsLogo.svg";
import bristolMyersLightTheme from "../../assets/image/bristolMyersLightTheme.svg";

import "./DigitalSignageAreaHeader.scss";

interface IHeaderProps {
  theme: boolean;
  absorptionCount: number | string;
  gallonsOfGas: number | string;
  carsRemoved: number | string;
  siteName: string;
  siteImage: string;
}
const isSiteImageValid = (image: string | undefined): boolean => {
  return !!image && image.startsWith("data:image/"); // Check if the image is not empty and starts with "data:image/"
};
const DigitalSignageAreaHeader = (props: IHeaderProps) => {
  const {
    theme,
    absorptionCount,
    gallonsOfGas,
    carsRemoved,
    siteName,
    siteImage,
  } = props;
  const headerThemeClass = theme ? "header-dark" : "header-light";
  const topHeaderThemeClass = theme ? "header-top-dark" : "header-top-light";
  const valueThemeClass = theme ? "value-dark" : "value-light";
  const siteNameThemeClass = theme ? "site-name-dark" : "site-name-light";
  const iconThemeClass = theme ? "icon-dark" : "icon-light";
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const orientation =
  window.screen.orientation?.type ||
  (screenWidth > screenHeight ? "landscape-primary" : "portrait-primary");
  return (
    <div className="header-container">
      {/* Top Row */}
      <div className="header-top">
        <div className={`company-parent ${isSiteImageValid(siteImage) ? orientation === 'portrait-primary' ? "company-parent-NoGap" :  "company-parent-Gap" : "company-parent-NoGap"}`}>
         <div className="icon-company">
         {isSiteImageValid(siteImage) && <img className="bms-logo" src={siteImage} />}
          </div>
          <div className={`site-name ${siteNameThemeClass}`}>
            <img src={theme ? location : location_light} alt="Location" />
            <span>{siteName}</span>
          </div>
        </div>

        <div className="powered">
          <span className={`poweredSpan ${siteNameThemeClass}`}>
            <div>Powered by</div>
            <div>Honeywell Forge</div>
          </span>
          <div style={{ position: "relative" }}>
            <img src={powerlogo} />
          </div>
        </div>
      </div>

      {/* Bottom Row Stats */}
      <div className="header-bottom">
        <InlineStat
          icon={tree}
          title="Equivalent carbon sequestered by"
          value={absorptionCount}
          unit="urban tree seedlings grown for 10 years"
          name="tree"
          headerThemeClass={headerThemeClass}
          topHeaderThemeClass={topHeaderThemeClass}
          valueThemeClass={valueThemeClass}
        />

        <InlineStat
          icon={petrolpump}
          title="Equivalent to CO₂e emissions by"
          value={gallonsOfGas}
          unit="gallons of gasoline consumed"
          name="petrolpump"
          headerThemeClass={headerThemeClass}
          topHeaderThemeClass={topHeaderThemeClass}
          valueThemeClass={valueThemeClass}
        />

        <InlineStat
          icon={car}
          title="Equivalent to CO₂e emissions by"
          value={carsRemoved}
          unit=" gasoline-powered passenger vehicles removed from the road per year"
          name="car"
          headerThemeClass={headerThemeClass}
          topHeaderThemeClass={topHeaderThemeClass}
          valueThemeClass={valueThemeClass}
        />
      </div>
    </div>
  );
};

export default DigitalSignageAreaHeader;
